


































































































// @ts-nocheck
import { defineComponent, SetupContext } from '@vue/composition-api'
// import { mapMutations } from 'vuex'
// import { companyGoV3 } from '@/apis/index'
import { getSVGGSize, getElementSize, getTransform } from '@/utils/element'
import { formatNumberWithComma } from '@/utils/text'
// import { COMPANY_ITEM_MAP } from '@/const/codes.ts'
import * as screenImageGetter from '@/utils/screenImageGetter'
import getNodeOffset from './getNodeOffset'
import ChartCard from '@/components/charts/ChartCard.vue'
import { D3ModuleContainer } from '@bpchart/vue'
import EmptyDataNotify from '@/components/EmptyDataNotify.vue'
import { chartDirected } from '@bpchart/d3-modules'
// import CompanySummaryLightbox from '@/components/CompanySummaryLightbox/CompanySummaryLightbox.vue'
import { isCompanyClosed, returnTags, createTagTooltipText } from '../../../utils/parseGoData'
import { Shareholder } from '@/types/graphics/goV3'
import moment from 'moment'
import { GoNode, GoEdge, PersonPayloadBasic, CompanyPayloadBasic } from '@/types/graphics/goV3'
import createChartHtml from '@/utils/createChartHtml'
// import { htmlToImageBuffer } from '@/apis'
import toOldFormat from '@/utils/to_old_format_v4.js'
import { EMPTY_DATA_NOTIFY } from '@/const/codes.ts'

declare module $nuxt {
  const $store: any
}

type SourceData = { edges: Array<GoEdge>, nodes: Array<GoNode> }

const defaultTitle = '法人董事'

const footerHeight = 22

const defaultChartParams = {
  styles: {
    // 根節點
    circleRoot: 'stroke-width: 5px; fill: #CC0000;',
    // 歇業的根節點
    circleRootClosed: 'stroke-width: 5px; fill: #DCDFE6;',
    // 公司節點
    // circleCompany: 'stroke: #909399;stroke-width: 5px; fill: #fff;',
    // 政府節點
    circleGov: 'stroke: #F5DAB1;stroke-width: 1px; fill: #FDF6EC;',
    // 外資法人節點
    circleForeign: 'stroke: #5EC5D7;stroke-width: 1px; fill: #E6F7FA;',
    // 自然人節點
    circlePerson: 'stroke: #C2E7B0;stroke-width: 1px; fill: #F0F9EB;',
    // 法人節點
    circleCompany: 'stroke: #D099EB;stroke-width: 1px; fill: #F7E6FA;',
    // 歇業的公司節點
    circleCompanyClosed: 'stroke: #c0c4cc;stroke-width: 1px; fill: #DCDFE6;',
    // 自然人節點
    // circlePerson: 'stroke: #909399;stroke-width: 2px; fill: #fff;',
    // 節點文字
    // circleText: 'fill: #303133; font-weight: normal',
    // 政府節點文字
    circleTextGov: 'fill: #E6A23C; font-weight: normal',
    // 外資法人節點文字
    circleTextForeign: 'fill: #43A7B9; font-weight: normal',
    // 自然人節點文字
    circleTextPerson: 'fill: #67C23A; font-weight: normal',
    // 法人節點文字
    circleTextCompany: 'fill: #A261C2; font-weight: normal',
    // 歇業的公司節點文字
    circleTextClosed: 'fill: #303133; font-weight: normal',
    // 根節點文字
    circleRootText: 'fill: #FFFFFF; font-weight: bold',
    // 歇業的根節點文字
    circleRootTextClosed: 'fill: #CC0000; font-weight: bold',
    // 線文字
    pathText: 'fill: #606266; font-weight: normal; font-size: 13px; text-shadow: 0 1px 0 #fff, 1px 0 0 #fff, 0 -1px 0 #fff, -1px 0 0 #fff;pointer-events: none;',
    // 上游的線
    // pathTop: 'stroke: #909399; stroke-width: 2px; fill:none;',
    // 上游政府的線
    pathTopGov: 'stroke: #F5DAB1; stroke-width: 2px; fill:none;',
    // 上游外資法人的線
    pathTopForeign: 'stroke: #5EC5D7; stroke-width: 2px; fill:none;',
    // 上游自然人的線
    pathTopPerson: 'stroke: #C2E7B0; stroke-width: 2px; fill:none;',
    // 上游法人的線
    pathTopCompany: 'stroke: #D099EB; stroke-width: 2px; fill:none;',
    // 上游歇業公司的線
    pathTopClosed: 'stroke: #c0c4cc; stroke-width: 2px; fill:none;',
    // 下游的線
    // pathDown: 'stroke-dasharray: 8; stroke: #909399; stroke-width: 2px; fill:none;',
    // 下游政府的線
    pathDownGov: 'stroke-dasharray: 8; stroke: #F5DAB1; stroke-width: 2px; fill:none;',
    // 下游外資法人的線
    pathDownForeign: 'stroke-dasharray: 8; stroke: #5EC5D7; stroke-width: 2px; fill:none;',
    // 下游自然人的線
    pathDownPerson: 'stroke-dasharray: 8; stroke: #C2E7B0; stroke-width: 2px; fill:none;',
    // 下游法人的線
    pathDownCompany: 'stroke-dasharray: 8; stroke: #D099EB; stroke-width: 2px; fill:none;',
    // 下游歇業公司的線
    pathDownClosed: 'stroke-dasharray: 8; stroke: #c0c4cc; stroke-width: 2px; fill:none;',
    // 指標
    // arrow: 'fill: #909399',
    // 政府指標
    arrowGov: 'fill: #f5dab1',
    // 外資法人指標
    arrowForeign: 'fill: #5EC5D7',
    // 自然人指標
    arrowPerson: 'fill: #C2E7B0',
    // 法人指標
    arrowCompany: 'fill: #D099EB',
    // 歇業公司的指標
    arrowClosed: 'fill: #909399',
    // 鎖定的節點
    circleLocked: 'stroke: #c00',
    // 鎖定的線
    pathLocked: 'stroke: #c00',
    // 鎖定的指標
    arrowLocked: 'fill: #c00',
    // 展開按鈕
    expandBtn: 'fill:#000000'
  },
  arrows: ['arrowGov', 'arrowForeign', 'arrowPerson', 'arrowCompany', 'arrowClosed', 'arrowLocked'],
  circlesR: {
    circleRoot: 60,
    circleRootClosed: 60,
    circleGov: 60,
    circleForeign: 60,
    circlePerson: 30,
    circleCompany: 60,
    circleCompanyClosed: 60
  }
}

// const logoSvg = '<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 279.92 100.61" height="20"><defs><style>.cls-1{fill:#1778f5;}.cls-2{fill:#7fb5f9;}.cls-3{fill:#ffd200;}.cls-4{fill:none;stroke:#306db4;stroke-miterlimit:10;stroke-width:0.5px;}</style></defs><title>資產 1</title><g id="圖層_2" data-name="圖層 2"><g id="圖層_1-2" data-name="圖層 1"><path class="cls-1" d="M166.38,34.33H145.72v15.4h4.51V47.82h16.15v1.91h4.51V34.33Zm0,9.49H150.23v-5.5h16.15Z"/><polygon class="cls-1" points="173.09 27.41 160.65 27.41 160.65 23.09 171.29 23.11 169.53 18.92 160.65 18.94 160.65 14.27 155.96 14.27 155.96 18.95 150.14 18.97 151.84 15.48 151.72 15.21 147.16 15.21 142.15 24.97 142.26 25.21 147.12 25.15 148.14 23.05 155.96 23.07 155.96 27.41 141.41 27.41 141.41 31.88 174.97 31.88 173.09 27.41"/><polygon class="cls-1" points="106.24 19.81 131.5 20.01 131.23 23.32 134.68 23.36 134.72 18.59 134.73 18.59 134.73 16.67 121.49 16.67 122.45 13.48 120.38 13.48 116.72 13.48 114.64 13.48 115.61 16.67 102.37 16.67 102.31 23 105.8 23.04 106.24 19.81"/><path class="cls-1" d="M129.31,24.5l.29-2.88-21.53-.19-.4,2.89-6.43-.05,0,3.23,6,.05-.4,3,21.86.19.33-3,6.89.06,0-3.23Zm-13.16,3.85-5-.05.17-1.21,5,0Zm.41-3.46-5,0,.16-1.1,5,0Zm8.19,3.53-4.91,0,.16-1.22,4.87,0Zm.33-3.46-4.79,0,.08-1.1,4.8,0Z"/><path class="cls-1" d="M126.3,44.55l4.51,0,.11-12.32-24.8-.21L106,44.38l3.85,0-5.78,2.74,0,.18,3,2.32,8.11-3.85.06-.21-1.52-1.15,8.61.08-1.67,1.27,0,.2,8.3,3.75,3.75-2.35,0-.18Zm-.07-2.24-15.82-.14V41l15.82.13Zm0-3.35-15.82-.13V37.65l15.82.13Zm0-3.35-15.82-.13v-1.1l15.82.13Z"/><path class="cls-2" d="M221.8,100.61H277a3,3,0,0,0,3-3V16.45a3,3,0,0,0-3-3h-55.9l43.69,42.74a2.91,2.91,0,0,1,.05,4.1L226.22,99.74a2.91,2.91,0,0,1-2.07.87m-2.35,0h-1.31"/><path class="cls-3" d="M213.72,100.56h0l0,0h.54A2.47,2.47,0,0,1,213.72,100.56Z"/><path class="cls-3" d="M264.74,56.22,208.11.83a2.89,2.89,0,0,0-4.09,0L201.2,3.74l53.65,52.48a2.9,2.9,0,0,1,0,4.1L216.33,99.74a2.91,2.91,0,0,1-2.07.87h9.89a2.91,2.91,0,0,0,2.07-.87l38.57-39.42A2.91,2.91,0,0,0,264.74,56.22Z"/><path class="cls-1" d="M254.85,56.22,198.22.83a2.9,2.9,0,0,0-4.1,0L178.91,16.41a3,3,0,0,0-.57,3.2l33.25,79.23a2.88,2.88,0,0,0,2.13,1.72,2.47,2.47,0,0,0,.54,0,2.91,2.91,0,0,0,2.07-.87l38.56-39.42A2.9,2.9,0,0,0,254.85,56.22Z"/><polygon class="cls-1" points="32.58 72.37 32.65 72.29 32.65 71.52 14.85 54.71 39.12 54.71 39.12 44.77 0 44.77 0 53.59 17.88 71.94 0 90.83 0 99.58 39.51 99.58 39.51 89.63 16.54 89.63 32.58 72.37"/><path class="cls-1" d="M71.06,88.81a8.13,8.13,0,0,1-2.89,2.47,9.06,9.06,0,0,1-4.25,1,9.6,9.6,0,0,1-3.86-.76,9.05,9.05,0,0,1-3-2.12,9.84,9.84,0,0,1-2-3.27,12,12,0,0,1-.72-4.23,11.63,11.63,0,0,1,.72-4.15,10,10,0,0,1,2-3.27,9.11,9.11,0,0,1,3.07-2.17,10.1,10.1,0,0,1,7.77,0,6.81,6.81,0,0,1,3,2.31l.19.27,6.12-6.12L77,68.5a14.21,14.21,0,0,0-5.89-3.89,21.72,21.72,0,0,0-14.86,0,18,18,0,0,0-6.09,3.72,17.27,17.27,0,0,0-4.07,5.87,20.71,20.71,0,0,0,0,15.25,18,18,0,0,0,4,5.92,17.76,17.76,0,0,0,6,3.81,20.63,20.63,0,0,0,7.55,1.35,19.05,19.05,0,0,0,7.93-1.57,17,17,0,0,0,5.79-4.28l.18-.2-6.28-5.91Z"/><path class="cls-1" d="M118,74.1a16.8,16.8,0,0,0-4-5.82,17.69,17.69,0,0,0-6.11-3.69,22.23,22.23,0,0,0-7.66-1.29,22,22,0,0,0-7.64,1.29,17.78,17.78,0,0,0-5.44,3.11l6.54,6.23a9.39,9.39,0,0,1,2.61-1.72,9.64,9.64,0,0,1,3.93-.79,9.75,9.75,0,0,1,3.93.79,9.17,9.17,0,0,1,3.05,2.14,9.74,9.74,0,0,1,2,3.28,11.81,11.81,0,0,1,.71,4.12,12.34,12.34,0,0,1-.71,4.25,9.71,9.71,0,0,1-2,3.32,9.23,9.23,0,0,1-3,2.17,10.12,10.12,0,0,1-7.84,0,8.91,8.91,0,0,1-2.9-2l-6.11,6.61a18.3,18.3,0,0,0,5.28,3.11,22.56,22.56,0,0,0,15.32,0A18,18,0,0,0,114,95.35a17.43,17.43,0,0,0,4-5.95,20.91,20.91,0,0,0,0-15.3Z"/><path class="cls-3" d="M93.26,89.32l.11.13-6.11,6.61c-.28-.23-.54-.46-.79-.71a17.46,17.46,0,0,1-4-5.95,21,21,0,0,1,0-15.3,16.83,16.83,0,0,1,4-5.82c.21-.2.42-.39.65-.58l6.54,6.23-.44.43a9.41,9.41,0,0,0-2,3.27,11.76,11.76,0,0,0-.69,4.12A12.11,12.11,0,0,0,91.27,86,9.67,9.67,0,0,0,93.26,89.32Z"/><path class="cls-1" d="M148.28,85.49a10.19,10.19,0,0,1-.33,2.63,6.11,6.11,0,0,1-1.08,2.18,5.29,5.29,0,0,1-1.94,1.52,7.79,7.79,0,0,1-5.8,0,5.08,5.08,0,0,1-1.91-1.52,6.5,6.5,0,0,1-1.08-2.19,9.32,9.32,0,0,1-.36-2.62V64.23h-8.92v22A15.54,15.54,0,0,0,127.92,92a12.8,12.8,0,0,0,3,4.53,14,14,0,0,0,4.76,2.93,19.31,19.31,0,0,0,12.56,0,14.21,14.21,0,0,0,4.83-2.93A12.69,12.69,0,0,0,156.17,92a15.25,15.25,0,0,0,1.08-5.83v-22h-9Z"/><polygon class="cls-1" points="188.43 64.22 162.37 64.22 162.37 71.96 172.19 71.96 172.19 99.58 181.16 99.58 181.16 71.96 191.68 71.96 188.43 64.22"/><line class="cls-4" x1="93.68" y1="73.94" x2="93.66" y2="73.93"/></g></g></svg>'

// function hasNode (nodes, itemUniID, itemName) {
//   return nodes.some(d => {
//     return d.id === itemUniID || (itemName != null && d.id === itemName)
//   })
// }

// function hasLink (links, _source, _target) {
//   return links.some(d => d._source === _source && d._target === _target)
// }

// @Q@ v2版go用的
const parseChartData = (sourceNodes: Array<GoNode>, sourceEdges: Array<GoEdge>, rootID: string, roleStyleMap: any): chartDirected.ChartDirectedForceDataset => {

  const chartNodes: Array<chartDirected.ChartDirectedForceNode> = sourceNodes.map(sourceNode => {
    let circle = ''
    let circleText = ''
    if (sourceNode.uniID === rootID) {
      if (isCompanyClosed((sourceNode as GoNode<any>).detail.payload.basic.company_operate)) {
        circle = 'circleRootClosed'
        circleText = 'circleRootTextClosed'
      } else {
        circle = 'circleRoot'
        circleText = 'circleRootText'
      }
    } else if (isCompanyClosed((sourceNode as GoNode<any>).detail.payload.basic.company_operate)) {
      circleText = 'circleTextClosed'
      circle = 'circleCompanyClosed'
    } else if (sourceNode.role && roleStyleMap[sourceNode.role]) {
      circle = roleStyleMap[sourceNode.role].circle
      circleText = roleStyleMap[sourceNode.role].circleText
    }

    // const tags = returnTags(sourceNode)
    // const tag = tags && tags[0] ? tags[0].text : undefined
    let tag = undefined
    if (sourceNode.name_PEP_name || sourceNode.name_PEP_family) {
      tag = '政'
    }
    
    return {
      id: sourceNode.uniID,
      uniID: sourceNode.uniID,
      label: sourceNode.name,
      style: {
        circle,
        circleText
      },
      // tooltip: createTooltipText(sourceNode.detail.payload.basic.shareholders),
      tooltip: (d: chartDirected.ChartDirectedForceNode) => {
        return createTooltipText(d?.data?.detail?.payload?.basic?.shareholders ?? [])
      },
      hasTop: false, // 後面程式再計算
      isTopExpanded: false,
      tag,
      // tagTooltip: returnTagTooltip(sourceNode),
      tagTooltip: (d: chartDirected.ChartDirectedForceNode) => {
        return createTagTooltipText(d.data)
      },
      // data: sourceNode, // 原始資料
      data: {
        detail: sourceNode.detail,
        role: sourceNode.role
      }
    } as chartDirected.ChartDirectedForceNode
  })

  // 將根節點移到第一個
  const rootNodeIndex = chartNodes.map(d => d.id).indexOf(rootID)
  if (rootNodeIndex > 0) {
    chartNodes.splice(0, 0, chartNodes[rootNodeIndex])
    chartNodes.splice(rootNodeIndex + 1, 1)
  }
  
  const NodesMap = new Map(chartNodes.map(d => {
    return [
      d.id,
      d
    ]
  }))

  const chartEdges: Array<chartDirected.ChartDirectedForceLink> = sourceEdges.map(sourceEdge => {
    const startData = NodesMap.get(sourceEdge['source-uniID'])
    const endData = NodesMap.get(sourceEdge['target-uniID'])
    const direction = startData && startData.id === rootID ? 'down' : 'top'
    let isClosed = false
    if (startData && direction === 'top') {
      isClosed = isCompanyClosed(
        (startData.data as GoNode<CompanyPayloadBasic>).detail.payload.basic.company_operate
      )
    } else if (endData && direction === 'down') {
      isClosed = isCompanyClosed(
        (endData.data as GoNode<CompanyPayloadBasic>).detail.payload.basic.company_operate
      )
    }

    let path = ''
    let arrow = ''
    if (isClosed) {
      arrow = 'arrowClosed'
      if (direction === 'top') {
        path = 'pathTopClosed'
      } else {
        path = 'pathDownClosed'
      }
    } else if (startData
    && startData.data
    && startData.data.role
    && roleStyleMap[startData.data.role]) {
      arrow = roleStyleMap[startData.data.role].arrow
      if (direction === 'top') {
        path = roleStyleMap[startData.data.role].pathTop
      } else {
        path = roleStyleMap[startData.data.role].pathDown
      }
    }

    return {
      id: sourceEdge.id,
      source: sourceEdge['source-uniID'],
      target: sourceEdge['target-uniID'],
      _source: sourceEdge['source-uniID'], // 因為"source"傳入d3的function之後資料會被渲染，所以多留一份原始資料
      _target: sourceEdge['target-uniID'], // 因為"target"傳入d3的function之後資料會被渲染，所以多留一份原始資料
      // routeIndex: string; // 路徑索引（非維一值）
      label: sourceEdge['edge-role'],
      direction,
      percentage: sourceEdge.percentage,
      style: {
        path,
        arrow
      }
    }
  })

  modifyHasTopBtnStatus(chartNodes, chartEdges, false, rootID)

  modifyDirectionStatus(chartEdges, rootID)

  return {
    nodes: chartNodes,
    links: chartEdges,
    expandAll: false,
  }
}

const modifyHasTopBtnStatus = (
  allNodes: Array<chartDirected.ChartDirectedForceNode>,
  allLinks: Array<chartDirected.ChartDirectedForceLink>,
  defaultExpanded: boolean,
  rootID: string
) => {
  for (let node of allNodes) {
    // 先假設無上層
    node.hasTop = false
    node.isTopExpanded = false
    // 根節點無展開按鈕
    if (node.id === rootID) {
      continue // 檢查下一個node
    }
    let hasTop = allLinks.some(link => {
      // 非node的上層
      if (link._target !== node.id) {
        return false
      }
      // 如果上層為根節點則無展開按鈕
      if (link._source === rootID) {
        return false
      }
      // 有上層且非根節點
      return true
    })
    if (hasTop) {
      node.hasTop = true
      node.isTopExpanded = defaultExpanded // 預設是否展開
    }
  }
}

const modifyDirectionStatus = (
  allLinks: Array<chartDirected.ChartDirectedForceLink>,
  rootID: string
) => {
  // 先全部預設為'top'
  for (const link of allLinks) {
    link.direction = 'top'
  }
  // 修改direction資料（遞迴）
  let checkedLink: Array<chartDirected.ChartDirectedForceLink> = []
  const modifyDownLinks = (nodeID: string) => {
    for (const link of allLinks) {
      if (checkedLink.find(l => link._source === l._source && link._target === l._target)) {
        continue
      }
      if (link._source === nodeID && link._target !== rootID) { // 要加上link._target !== this.rootID這個條件，否則同時是根節點的上流及下流的節點也會被誤判為top
        checkedLink.push(link)
        link.direction = 'down'
        // modifyDownLinks(link._target) // 往下找
      }
    }
  }
  // 從根節點開始往下找
  modifyDownLinks(rootID)
}

function createTooltipText (shareholders: Array<Shareholder>) {
  return shareholders
    .map(d => {
      let bracketText = ''
      if (d.ROL) {
        bracketText += d.ROL
      }
      if (d.title) {
        if (bracketText) {
          bracketText += '，'
        }
        bracketText += d.title
      }
      if (d.stocks) {
        if (bracketText) {
          bracketText += '，'
        }
        bracketText += `持股 ${formatNumberWithComma(d.stocks)}`
      }
      return `${d.name}（${bracketText}）`
    })
    .join('</br>')
}

// function returnTagTooltip ({ pepName = [], pepFamily = [], name }) {
//   let text = ''
//   try {
//     if (pepName.length) {
//       pepName.map(pepName => {
//         let positionAndExperience = (pepName.position || []).concat(pepName.experience || [])
//         positionAndExperience = positionAndExperience.filter(d => d !== '無')
//         text += '．與列名 PEPS 者同名'
//         text += `</br><span style="margin-left:15px">曾任 ${positionAndExperience.join('、')}</span>`
//       })
//     }
//     if (pepFamily.length) {
//       pepFamily.map(pepFamily => {
//         let positionAndExperience = (pepFamily.position || []).concat(pepFamily.experience || [])
//         positionAndExperience = positionAndExperience.filter(d => d !== '無')
//         if (text) {
//           text += '</br>'
//         }
//         text += '．與列名 PEPS 者之家屬同名'
//         text += `</br><span style="margin-left:15px">曾任 ${positionAndExperience.join('、')}</span>`
//       })
//     }
//   } catch (e) { console.error(e) }

//   return text
// }

export default defineComponent({
  props: {
    cardId: {
      default () {
        return 'companyStockDirectedChart'
      }
    },
    // demoMode: {
    //   required: false,
    //   default () {
    //     return false
    //   }
    // },
    'uniID': {
      required: true
    },
    'companyName': {
      required: true
    },
    options: {
      default () {
        return {
          expandAll: false, // 展開所有節點
          mergeName: false // 合併相同姓名
        }
      }
    },
    // // 圖表所需的所有節點資料（api的原始結構未parse）
    // companyDataList: {
    //   // required: true
    //   default () {
    //     return []
    //   }
    // },
    // 圖表所需的所有節點資料（api的原始結構未parse）
    sourceData: {
      type: Object as () => SourceData,
      default () {
        return {
          edges: [],
          nodes: []
        }
      }
    },
    // chartData: {
    //   type: Object as () => chartDirected.ChartDirectedForceDataset,
    //   default () {
    //     return {
    //       edges: [],
    //       nodes: [],
    //       expandAll: false,
    //     }
    //   }
    // },
    height: {
      default () {
        return 800
      }
    }
  },
  components: {
    D3ModuleContainer,
    ChartCard,
    EmptyDataNotify
    // CompanySummaryLightbox
  },
  data () {
    return {
      EMPTY_DATA_NOTIFY,
      isProduction: process.env.VUE_APP_MODE === 'production',
      ChartDirectedForce: chartDirected.ChartDirectedForce,
      // cardId: 'companyStockDirectedChart',
      cardTooltip: `企業關聯圖譜係依您所查詢之公司，並根據經濟部 OPEN DATA 進行關聯運算之網絡圖。<br>
                  ．箭頭所流向之單位，表示為公司所投資之對象或擔任其董事、監察人。<br>
                  ．箭頭所源於之單位或自然人，表示為公司之董監事或監察人。`,
      cardWidth: 0 as number | string,
      cardHeight: 0 as number | string,
      headerHeight: 45,
      currentChartData: {
        nodes: [],
        links: [],
        expandAll: false
      } as chartDirected.ChartDirectedForceDataset,
      updateKey: Number(new Date()), // 強制變更資料
      isShowChart: true,
      isFullScreen: false,
      isDownloading: false,
      screenShotMode: false,
      screenShotModeChart: false, // 圖表本身的screenShotMode
      autoZoom: false, // 螢幕變換尺寸時 zoom還原預設（用於縮放全螢幕時）
      lockMode: false,
      highlightId: undefined as string | undefined,
      keyword: '',
      isSearchPopoverVisible: false,
      chartZoom: undefined as any,
      // svgSelector: undefined as SVGElement | undefined,
      // gSelector: undefined as SVGGElement | undefined,
      // isCompanyLightboxVisible: false,
      // companyLightboxBasic: {},
      // rootID: '',
      loadedNodeUniIDs: [], // 紀錄已載入進來的所有node id
      roleStyleMap: {
        政府機關: {
          circle: 'circleGov',
          circleText: 'circleTextGov',
          pathTop: 'pathTopGov',
          pathDown: 'pathDownGov',
          arrow: 'arrowGov'
        },
        外資法人: {
          circle: 'circleForeign',
          circleText: 'circleTextForeign',
          pathTop: 'pathTopForeign',
          pathDown: 'pathDownForeign',
          arrow: 'arrowForeign'
        },
        自然人: {
          circle: 'circlePerson',
          circleText: 'circleTextPerson',
          pathTop: 'pathTopPerson',
          pathDown: 'pathDownPerson',
          arrow: 'arrowPerson'
        },
        法人: {
          circle: 'circleCompany',
          circleText: 'circleTextCompany',
          pathTop: 'pathTopCompany',
          pathDown: 'pathDownCompany',
          arrow: 'arrowCompany'
        }
      },
    }
  },
  computed: {
    syncOptions: {
      get () {
        return this.options
      },
      set (d) {
        this.$emit('update:options', d)
      }
    },
    cardTitle () {
      return `【${this.companyName}】企業關聯圖譜`
    },
    cardSizeState () {
      return {
        isFullScreen: this.isFullScreen,
        screenShotMode: this.screenShotMode
      }
    },
    outerContainerSize () {
      if (this.isFullScreen) {
        return {
          position: 'fixed',
          width: '100vw',
          height: '100vh',
          top: '0px',
          left: '0px',
          'z-index': 2000
        }
      } else {
        return {
          position: 'relative',
          width: '100%',
          height: `${this.height}px`
        }
      }
    },
    fullScreenIcon () {
      if (this.isFullScreen) {
        return 'compress'
      } else {
        return 'expand'
      }
    },
    rootID () {
      return this.uniID
      // return '80333183'
      // this.basic.uniID
    },
    chartParams () {
      return {
        ...defaultChartParams,
        key: this.updateKey, // 強制變更資料
        screenShotMode: this.screenShotModeChart,
        autoZoom: this.autoZoom,
        lockMode: this.lockMode,
        highlightId: this.highlightId
      }
    },
    isShowChartContainer () {
      // console.log('isShowChartContainer', this.currentChartData.nodes.length)
      // 1筆代表只有根節點本身
      return (this.currentChartData.nodes && this.currentChartData.nodes.length > 1)
        ? true
        : false
    }
  },
  watch: {
    cardSizeState: {
      handler (cardSizeState) {
        if (cardSizeState.screenShotMode === true && document) {
          // 取得寬高
          const screenShotSize = getSVGGSize(document.querySelector('.bp__force-directed-chart__g'))
          // 將卡片寬高設為和符合圖表尺寸（圖表寬高加上卡片間距）
          // let width = screenShotSize.width + this.cardStyle['padding-left'] + this.cardStyle['padding-right']
          // let height = screenShotSize.height + this.cardStyle['padding-top'] + this.cardStyle['padding-bottom'] + this.cardStyle.header.height + this.cardStyle.footer.height + 20
          let width = screenShotSize.width + 140 // 圖表寬高加上卡片間距
          let height = screenShotSize.height + this.headerHeight + footerHeight + 120 // 圖表寬高加上卡片間距
          width = width * 1.15
          height = height * 1.15
          if (width < 640) {
            width = 640
          }
          if (height < 480) {
            height = 480
          }
          this.cardWidth = width
          this.cardHeight = height
        } else if (cardSizeState.isFullScreen === true) {
          this.cardWidth = '100vw'
          this.cardHeight = '100vh'
        } else {
          this.cardWidth = '100%'
          this.cardHeight = `${this.height}px`
        }
      },
      immediate: true
    },
    sourceData: {
      handler (d) {
        this.setChartData(d)
      },
      immediate: true
    },
    // chartData: {
    //   handler (d) {
    //     if (d && d.nodes) {
    //       this.setChartData(d, true)
    //     }
    //   },
    //   immediate: true
    // }
  },
  methods: {
    // ...mapMutations([
    //   'mutationIsBlurboxActive'
    // ]),
    setChartData (d: SourceData | chartDirected.ChartDirectedForceDataset) {
      if (d && d.nodes) {
        // if (demo === true) {
        //   this.currentChartData = d as chartDirected.ChartDirectedForceDataset
        //   return
        // }
        const data = d as SourceData
        this.currentChartData = parseChartData(data.nodes, data.edges, this.rootID, this.roleStyleMap)
        console.log('setChartData', this.currentChartData)
      }
    },
    // async resetChart () {
    //   // 先解除鎖定
    //   this.lockMode = false
    //   // 更新圖表
    //   this.isShowChart = false
    //   this.currentChartData = {
    //     nodes: [],
    //     links: [],
    //     expandAll: false
    //   }
    //   this.isLoading = true
    //   const result: any = await companyGoV3({
    //     uniid: this.rootID,
    //     mode: 'up',
    //     format: 'json',
    //     scope: "classic",
    //     force_split: this.syncOptions.mergeName == true ? 0 : 1
    //   }, $nuxt.$store.state)
    //   // 重新建立節點資料
    //   const parsedData = toOldFormat(result)
    //   this.setChartData(parsedData.d3)
    //   await this.$nextTick()
    //   this.isLoading = false
    //   this.isShowChart = true
    //   // await this.$nextTick()
    //   // await new Promise(resolve => setTimeout(resolve, 1000))
    // },
    async toggleExpandedMode (isExpandAll: boolean) {
      this.isShowChart = false
      this.$set(this.syncOptions, 'expandAll', isExpandAll)
      // let currentChartData = JSON.parse(JSON.stringify(this.currentChartData))
      // if (this.syncOptions.expandAll) {
      //   this.setAllExpanded(currentChartData.nodes, currentChartData.links)
      // } else {
      //   this.setAllUnexpaned(currentChartData.nodes, currentChartData.links)
      // }
      // 修正是否有展開按鈕
      modifyHasTopBtnStatus(this.currentChartData.nodes, this.currentChartData.links, this.syncOptions.expandAll, this.rootID)

      this.currentChartData.expandAll = this.syncOptions.expandAll
      // this.currentChartData = currentChartData
      await this.$nextTick()
      this.isShowChart = true
    },
    // 由前端截圖（舊的做法）
    async download () {
      this.screenShotMode = true
      // const screenHotModeFooterHtml = `
      //   ${logoSvg}
      //   <span style="color:#1778f5;font-size:14px;margin-left:10px">
      //     圖表繪製時間 ${moment().format('YYYY/MM/DD HH:mm')}
      //   </span>
      //   `
      // this.$refs.chart.d3Module.setFooterHtml(screenHotModeFooterHtml)
      await new Promise(resolve => setTimeout(resolve, 1000))
      this.screenShotModeChart = true
      await new Promise(resolve => setTimeout(resolve, 200))
      
      let result = await screenImageGetter.downloadScreenImage(
        `#${this.cardId}`,
        `${this.cardTitle} ${moment().format('YYYY/MM/DD HH:mm')}`,
        '#app'
      )
      // this.$refs.chart.d3Module.setFooterHtml(logoSvg)
      this.screenShotMode = false
      await new Promise(resolve => setTimeout(resolve, 1000))
      this.screenShotModeChart = false
      
    },
    // async download () {
    //   this.isDownloading = true
    //   const fileTitle = `${this.cardTitle}_${moment().format('YYYY_MM_DD_HH_mm')}` 
    //   const chart = document.querySelector(`#${this.cardId} .chart-component svg`)
    //   const html = createChartHtml({
    //     chart,
    //     title: this.cardTitle,
    //     setChart: (chart, newChart) => {
    //       const g = chart.querySelector('g')
    //       const newChartG = newChart.querySelector('g')
    //       let { width, height } = getElementSize(g)
    //       const transform = getTransform(g) ?? {}
    //       // const translate = transform.translate.split(',')
    //       const scale: number = Number(transform.scale) ?? 1
    //       width = width / scale
    //       height = height / scale
          
    //       const nodeOffset = getNodeOffset(chart.querySelectorAll('.nodeG'))
          
    //       const padding = 40 // 留間隔
    //       const nodeR = 60 // 泡泡半徑
    //       const newX = -nodeOffset[0] + nodeR + padding
    //       const newY = -nodeOffset[1] + nodeR + padding
    //       newChartG.setAttribute('transform', `translate(${newX}, ${newY}) scale(1)`)
    //       newChart.setAttribute('width', width + padding * 2)
    //       newChart.setAttribute('height', height + padding * 2)
    //     }
    //   })
    //   const b64Data = await htmlToImageBuffer({
    //     html
    //   })
    //   const href = `data:image/png;base64,${b64Data}`
    //   const link = document.createElement('a');
    //   document.body.appendChild(link);
    //   link.href = href
    //   link.download = fileTitle
    //   link.click();
    //   this.isDownloading = false
    // },
    // 切換全營幕
    toggleFullScreen (isFullScreen: boolean) {
      this.autoZoom = true
      this.isFullScreen = isFullScreen
      $nuxt.$store.commit('mutationIsBlurboxActive', !this.isFullScreen) // 切換是否啟用背景（因backdrop-filter會影響到position:fixed）
      
      setTimeout(() => {
        this.autoZoom = false
      }, 800)
    },
    async handleDropdownClick (command: 'lock' | 'unlock' | 'expand' | 'compress' | 'download' | 'fullscreen' | 'originScreen') {
      this.updateKey = Number(new Date()) // 強制變更資料
      
      if (command === 'lock') {
        this.lockMode = true
      } else if (command === 'unlock') {
        this.lockMode = false
      } else if (command === 'expand') {
        this.lockMode = false
        this.toggleExpandedMode(true)
      } else if (command === 'compress') {
        this.lockMode = false
        this.toggleExpandedMode(false)
      } else if (command === 'download') {
        this.download()
      } else if (command === 'fullscreen') {
        this.toggleFullScreen(true)
      } else if (command === 'originScreen') {
        this.toggleFullScreen(false)
      }
    },
    handleKeywordChange () {
      if (!this.keyword || !(this.$refs.refChart as any) || !(this.$refs.refChart as any).d3Module) {
        this.chartZoom = undefined
        this.highlightId = undefined
        return
      }
      
      // console.log(this.refChart)
      let nodes = []
      if (this.$refs.refChart && (this.$refs.refChart as any).d3Module && (this.$refs.refChart as any).d3Module.renderData.nodes) {
        nodes = (this.$refs.refChart as any).d3Module.renderData.nodes
      }
      // console.log((this.$refs.refChart as any).d3Module)

      let findNode: any = null
      
      for (let node of nodes) {
        if ((node.label.includes(this.keyword) || node.uniID.includes(this.keyword))) {
          findNode = node
          this.highlightId = node.id
          break
        }
      }
      
      // console.log(findNode)
      // 找到節點
      if (findNode) {
        // 取得<g>場景尺寸
        const svgSelector = document.querySelector(`#ChartDirectedForce-${this.uniID} svg`) as SVGElement 
        // this.gSelector = document.querySelector(`#ChartDirectedForce-${this.uniID} g.bp__force-directed-chart__g`) as SVGGElement
        const svgSize = getElementSize(svgSelector)
        // const gSize = getSVGGSize(gSelector)
        // const gTransform: any = getTransform(gSelector!)


        // console.log(refChart)
        // debugger
        // const scale = Number(gTransform.scale) // svg尺寸會受到放大率的影響，所以要除回來
        this.chartZoom = {
          x: - (findNode.x - (svgSize.width / 2)),
          y: - (findNode.y - (svgSize.height / 2)),
          k: 1
        }
        // console.log(findNode.label, this.chartZoom)
      }
      
      // props.chartData.nodes.find(node => {
      //   node.
      // })
    }
  }
})
